var _module_exports = "<global-wrapper-react-footer language=language ng-if=isLanguageKeySet> <global-wrapper-react-footer-placeholder/> </global-wrapper-react-footer> ";;
var path = 'global-wrapper/v1/templates/footer.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;